import { Box, Flex } from '@chakra-ui/react';
import { specialFont } from 'constants/theme';
import SelectableOption from 'components/common/Selectable/SelectableOption';
import { IParameter } from '../../../../server/types';

const NonSelectable = ({ parameter, value }: { parameter: IParameter; value: string }) => {
  const renderParam = () => {
    if (value !== undefined) {
      return (
        <SelectableOption optionName={value} optionValue={undefined} selected={undefined} selectOption={() => {}} />
      );
    }
    return null;
  };

  const renderNote = () => {
    if (parameter.note !== '') {
      return (
        <Box
          sx={{
            color: 'red',
            fontFamily: specialFont,
            fontSize: 15,
            fontWeight: 'light',
            p: 1,
          }}
        >
          {parameter.note}
        </Box>
      );
    }

    return renderParam();
  };

  return (
    <Flex flex={1} flexDir="column">
      {renderNote()}
    </Flex>
  );
};

export default NonSelectable;
